import { useState, React, useEffect } from 'react';
import _noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
import { Delete } from 'sushiweb/Icons';
import grey from 'sushiweb/tokens/color/grey';
import { IconDiv } from '../../styles';
import ConfirmDeactivate from '../ConfirmDeactivate/ConfirmDeactivate';
import { applicableFlowTypes, currentFlowTypeEnum } from '../constants';

const RemoveEmployeeBtn = ({
  currentFlow,
  employee,
  fromGroup,
  removeEmployeeFromCompany,
  removedEmployeeSuccess,
  removingEmployeeSuccess,
  selectedWorkspace,
  getEmployeesForGroup,
  getAllEmployees,
  viewOnlyMode,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [actionMessage, setActionMessage] = useState('');
  const [loadEmployees, setLoadEmployees] = useState(false);
  const handleClickDelete = () => {
    setTitle(`Exit '${employee.email}'?`);
    setActionMessage(
      currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT
        ? 'Employee will not be able to place business orders on Zomato App'
        : 'No further top-ups will be made to the employee',
    );
    setIsVisible(true);
  };

  const closeActionConfirm = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    if (removedEmployeeSuccess && loadEmployees) {
      closeActionConfirm();
      if (fromGroup) {
        getEmployeesForGroup({
          groupId: employee.group_id,
          workspaceId: selectedWorkspace?.workspace_id ?? '',
        });
      } else {
        getAllEmployees(selectedWorkspace?.workspace_id ?? '');
      }
      setLoadEmployees(false);
    }
  }, [removedEmployeeSuccess, loadEmployees]);

  const handleAccept = () => {
    const body = {
      workspace_id: selectedWorkspace?.workspace_id,
      email_hash: employee.email_hash,
    };
    removeEmployeeFromCompany(body);
    setLoadEmployees(true);
  };

  return (
    <>
      <ConfirmDeactivate
        isVisible={isVisible && !viewOnlyMode}
        warning
        title={title}
        message={actionMessage}
        buttonLabel='Yes'
        denyButtonLabel='No'
        closeModal={closeActionConfirm}
        onContinueClick={handleAccept}
        loading={removingEmployeeSuccess}
      />
      <IconDiv>
        <Delete
          showPointer
          color={`${grey.z800}`}
          onClick={handleClickDelete}
          size={15}
          iconName='Delete'
          disabled={viewOnlyMode}
        />
      </IconDiv>
    </>
  );
};

RemoveEmployeeBtn.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  employee: PropTypes.objectOf(PropTypes.any),
  fromGroup: PropTypes.bool,
  removeEmployeeFromCompany: PropTypes.func,
  removingEmployeeSuccess: PropTypes.bool,
  removedEmployeeSuccess: PropTypes.bool,
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  getEmployeesForGroup: PropTypes.func,
  getAllEmployees: PropTypes.func,
  viewOnlyMode: PropTypes.bool,
};

RemoveEmployeeBtn.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  employee: {},
  removeEmployeeFromCompany: _noop,
  fromGroup: false,
  removingEmployeeSuccess: false,
  removedEmployeeSuccess: false,
  selectedWorkspace: {},
  getEmployeesForGroup: _noop,
  getAllEmployees: _noop,
  viewOnlyMode: false,
};

export default RemoveEmployeeBtn;
